
import '../../../node_modules/bootstrap/js/dist/collapse';
import '../../../node_modules/bootstrap/js/dist/dropdown';
import '../../../node_modules/bootstrap/js/dist/modal';
import '../../../node_modules/bootstrap/js/dist/tab';
import '../../../node_modules/bootstrap/js/dist/carousel';

const stickyNavScroll = () => {
  const stickyHeader = document.querySelector(".card-header.position-sticky");

  if (!stickyHeader) {
    return;
  }

  stickyHeader.querySelectorAll(".position-sticky button.nav-link").forEach((el) => {
    el.addEventListener("shown.bs.tab", (e) => {
      stickyHeader.parentElement.scrollIntoView();
    })
  });
};

stickyNavScroll();